import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { fDateTimeWithTimezone } from "../../../../../utils/formatTime";

OrderLogAddition.propTypes = {
  logItem: PropTypes.object,
  orderType: PropTypes.string,
}

export default function OrderLogAddition({ logItem, orderType }) {
  return <Box>
    <Typography variant="body" color="info.main" sx={{wordBreak: 'break-word', whiteSpace: 'normal'}}>
      {orderType} order created {logItem.addedBy ? `by ${logItem.addedBy}` : ''}
    </Typography>
    <Typography variant="body2" color="black">
      {fDateTimeWithTimezone(logItem.dateAdded)}
    </Typography>
  </Box>
}